export const NOME_LOGIN = 'Nome Login';
export const SENHA = 'Senha';
export const BLOQUEIO_ACESSO = 'Bloquear acesso ao Sistema';
export const DADOS_ACESSO = 'Dados de Acesso';
